<template>
	<div class="foot clearfix">
		<div class="foot_menu">
			<router-link to="/index">
				<div class="foot_menu_item">首&emsp;页</div>
			</router-link>
			<router-link to="/product">
				<div class="foot_menu_item">产&emsp;品</div>
			</router-link>
			<router-link to="/leavemsg">
				<div class="foot_menu_item">留&emsp;言</div>
			</router-link>
			<router-link to="/our">
				<div class="foot_menu_item">我&emsp;们</div>
			</router-link>
		</div>
		<div class="foot_address">
			<p>电话( TEL )：021-52366166 52366178 </p>
			<p>电子邮件( E-MAIL )：<a href='mailto:wellness@dkingsh.com'>wellness@dkingsh.com</a></p>
			<p>地址( ADD )：上海市徐汇区桂箐路7号G7-B201</p>
			<!-- <p>无锡( ADD )：无锡市团结南路1号红星美凯龙1号馆1楼BISAZZA</p> -->
		</div>
		<p class="cp">上海帝景卫浴设备有限公司 沪ICP备18004570号</p>
	</div>
</template>
<script>
	export default {
	  name: 'foot',
	  data(){
	  	return{
	  		
	  	}
	  },
	  mounted:function(){
	  	
	  },
	  methods:{

	  }
	  
	}
</script>
<style scoped>
	.foot{
		background-color: #fff;
		padding-top: 27px;
		min-width: 1200px;
		border-top: 1px solid #efefef;
	}
	.foot_menu{
		margin: 0 auto;
		text-align: center;
		margin-bottom: 36px;
	}
	.foot_menu_item{
		padding: 0 37px;
		display: inline-block;
		color: #656565;
		font-size: 14px;
		border-right: 1px solid #cecece;
	}
	.foot_menu_item:last-child{
		border-right: 0;
	}
	.foot_address p,.foot_address a{
		font-size: 14px;
		color: #898989;
		margin-bottom: 20px;
		text-align: center;
	}

	.cp{
		font-size: 14px;
		color: #898989;
		text-align: center;
		padding: 12px 0;
		border-top: 1px solid #cecece;
	}
</style>


// WEBPACK FOOTER //
// src/components/public/foot.vue